import type { TKey } from './types';

const ko: Record<TKey, string> = {
  'nav.library':            '라이브러리',
  'nav.myBooks':            '내 책',
  'nav.credentials':        '인증서',
  'nav.mindmap':            '마인드맵',
  'nav.reading':            '풀이',
  'nav.upload':             '책 올리기',
  'nav.signin':             '로그인',
  'nav.signout':            '로그아웃',
  'nav.localeSelect':       '언어 선택',

  'brand.sub':              '책퀘스트',
  'onboard.welcome':        '책 한 권으로 시작하세요',
  'onboard.welcomeSub':     '큐레이션된 책을 선택하거나 본인의 PDF를 올려 4-Layer 마인드맵과 9-Tier 적응 평가, 평생 인증서를 받아보세요.',
  'onboard.featureMapTitle':  '4-Layer 마인드맵',
  'onboard.featureMapBody':   '표면 줄거리(L1)부터 책에 없는 전제(L4)까지 — AI가 4개 층으로 풀어내는 지식 지도.',
  'onboard.featureQuizTitle': '9-Tier 적응 퀴즈',
  'onboard.featureQuizBody':  'IRT 기반으로 당신의 이해도에 맞춰 난이도(T1~T9)가 자동 조정됩니다.',
  'onboard.featureCredTitle': '평생 인증서',
  'onboard.featureCredBody':  '완독·통과한 모든 성취가 W3C VC로 발급되어 외부에서도 검증 가능.',
  'onboard.ctaBrowse':      '큐레이션 둘러보기',
  'onboard.ctaUpload':      '내 PDF 업로드',
  'onboard.signedOutHint':  '먼저 로그인하면 진행 상황이 저장됩니다.',
  'onboard.ctaSignIn':      '로그인 / 가입',
  'common.loading':         '불러오는 중…',
  'common.offline':         '오프라인',
  'common.free':            '무료',
  'common.error':           '오류',
  'common.back':            '← 라이브러리',
  'common.continue':        '계속',
  'common.submit':          '제출',
  'common.skip':            '건너뛰기',
  'common.next':            '다음',
  'common.finish':          '완료',
  'common.startAssessment': '평가만 시작',
  'theme.label':            '테마',
  'theme.light':            '밝게',
  'theme.dark':             '어둡게',
  'theme.system':           '시스템',
  'sound.label':            '효과음',
  'sound.on':               '켜짐',
  'sound.off':              '꺼짐',
  'api.error.badRequest':   '요청이 유효하지 않습니다.',
  'api.error.unauthorized': '로그인이 필요합니다.',
  'api.error.forbidden':    '이 자료에 접근 권한이 없습니다.',
  'api.error.notFound':     '찾을 수 없습니다 — 자료가 이동되었거나 삭제되었습니다.',
  'api.error.tooLarge':     '파일이 너무 큽니다. 100 MB 이내로 다시 시도하세요.',
  'api.error.unsupported':  '지원하지 않는 파일 형식입니다.',
  'api.error.rateLimited':  '요청이 너무 많습니다 — 잠시 후 다시 시도하세요.',
  'api.error.server':       '서버 오류 — 잠시 후 다시 시도하세요.',
  'api.error.network':      '네트워크 연결이 끊겼습니다.',
  'api.error.unknown':      '알 수 없는 오류',
  'a11y.skipToMain':        '본문으로 건너뛰기',
  'notFound.kicker':        'Not Found · 404',
  'notFound.titleLine1':    '이 경로는',
  'notFound.titleLine2':    '책장에 없습니다.',
  'notFound.lead':          '책이 옮겨졌거나 사라진 페이지입니다. 도서관으로 돌아가 다시 시작하세요.',
  'notFound.pathLabel':     '요청 경로',
  'notFound.cta':           '도서관으로',
  'footer.tagline':         '한 권이 마인드맵과 인증서가 되는 도서관',
  'footer.navLabel':        '푸터 메뉴',
  'footer.about':           '소개',
  'footer.privacy':         '개인정보',
  'footer.terms':           '약관',
  'footer.contact':         '연락처',
  'reader.controls':              '리더 컨트롤',
  'reader.size':                  '글자',
  'reader.theme':                 '테마',
  'reader.previewFallback':       '본문 미리보기가 준비되지 않았습니다. 책 분석이 완료되면 표시됩니다.',
  'reader.stubNotice':            'Reader 환경 미리보기. 본문 표시는 다음 릴리스에서 활성화됩니다.',
  'reader.demoBody1':             '독서 중 만나는 핵심 개념과 반박, 정의, 행동 단서는 색으로 표시됩니다.',
  'reader.demoBody2':             '용어는 별도로 정의하고,',
  'reader.demoBody3':             '독자가 시도해야 할 것은',
  'reader.demoHighlightYellow':   '핵심 개념',
  'reader.demoHighlightCoral':    '대립 명제',
  'reader.demoHighlightBlue':     '정의',
  'reader.demoHighlightMint':     '실천 항목',
  'reader.aside.legendLabel':     '색 범례',
  'reader.aside.legendYellow':    '핵심 개념',
  'reader.aside.legendCoral':     '대립·반박',
  'reader.aside.legendBlue':      '정의',
  'reader.aside.legendMint':      '실천 항목',
  'reader.aside.metaLabel':       '책 정보',
  'common.correct':         '정답입니다.',
  'common.notQuite':        '아쉬워요.',
  'common.save':            '나중에 읽기',
  'common.beginReading':    '풀이 시작',
  'common.openMindmap':     '마인드맵 열기',
  'common.searchPlaceholder': '제목·저자·ISBN으로 검색…',

  'library.kicker':         'Opening Collection · 100 vols',
  'library.heroLine1':      '100권의 시작,',
  'library.heroLine2':      '그리고 끝없는 책장.',
  'library.heroSub':        '오프닝 컬렉션 100선. 한 권이 4-Layer 마인드맵과 9-Tier 평가로 다시 태어나는 도서관.',
  'library.featured':       '이달의 추천',
  'library.curatedCount':   '큐레이션',
  'library.noBooks':        '큐레이션된 책이 없습니다. 시드 스크립트나 관리자 큐레이션을 이용하세요.',
  'library.filterAll':      '전체',
  'library.filterClassics': '고전',
  'library.filterPhilosophy': '철학',
  'library.filterK5':       '초등 (K-5)',
  'library.filter68':       '중등 (6-8)',
  'library.filter912':      '고등 (9-12)',

  'detail.previewNodes':    '4-Layer 마인드맵 미리보기',
  'detail.sampledQuestions': '세 문항 미리보기',
  'detail.bookMissing':     '책 정보를 가져올 수 없습니다.',
  'detail.noQuestions':     '문항이 아직 준비되지 않았습니다 — 파이프라인 처리 중일 수 있습니다.',
  'detail.byAuthor':        '저자',
  'detail.pages':           '쪽',
  'detail.metaSeparator':   ' · ',
  'detail.sourceLabel':            '출처',
  'detail.firstQuoteLabel':        '첫 인용',
  'detail.relatedCredentialLabel': '관련 인증서',
  'detail.relatedCredentialBody':  '이 책으로 Major 인증서를 획득할 수 있습니다.',

  'map.fourLayers':         '4-Layer',
  'map.navigation':         '이동',
  'map.surface':            'L1 표면',
  'map.argument':           'L2 논증',
  'map.concept':            'L3 개념',
  'map.meta':               'L4 메타 — 책에 없는 전제',
  'map.notReady':           '마인드맵이 아직 준비되지 않았습니다.',
  'map.loadingMap':         '마인드맵을 불러오는 중…',
  'map.selectNode':         '노드를 선택하세요',
  'map.selectNodeSub':      '각 노드는 인용(L1), 논증(L2), 개념(L3) 또는 침묵한 전제(L4)를 담고 있습니다.',
  'map.hoverHint':          '노드 위에 마우스를 올려보세요',

  'quiz.of':                ' / ',
  'quiz.minRemaining':      '분 남음 예상',
  'quiz.noQuestions':       '풀이 가능한 문항이 없습니다.',
  'quiz.tier':              '난이도',
  'quiz.celebration.kicker':         '완독',
  'quiz.celebration.titleLine1':     '한 권의 책을',
  'quiz.celebration.titleLine2':     '완성했습니다.',
  'quiz.celebration.lead':           '평가가 인증서로 봉인되었습니다. 평생 보관됩니다.',
  'quiz.celebration.correct':        '정답',
  'quiz.celebration.theta':          'θ 최종',
  'quiz.celebration.viewCredential': '인증서 보기',

  'creds.kicker':           '인증서',
  'creds.heroLine':         '당신이 얻은',
  'creds.heroEm':           '읽기의',
  'creds.heroSub':          '모든 마일스톤이 W3C Verifiable Credential 로 발급됩니다 — 외부 검증 가능, 평생 보관.',
  'creds.master':           'Master ★',
  'creds.recent':           '최근 발급',
  'creds.pastDays':         '최근 30일',
  'creds.noneYet':          '책을 완독하면 첫 인증서를 얻습니다.',
  'creds.urn':              'URN',
  'creds.issued':           '발급',
  'creds.anchor':           '닻',
  'creds.tier.micro':       '마이크로',
  'creds.tier.standard':    '스탠다드',
  'creds.tier.major':       '메이저',
  'creds.tier.master':      '마스터',
  'creds.tier.legendary':   '레전더리',
  'creds.count':            '장',
  'creds.aside.tiersLabel':    '5-Tier 사다리',
  'creds.aside.tiersBody':     'Micro → Standard → Major → Master → Legendary. 평생 80-100장 누적.',
  'creds.aside.verifyLabel':   '외부 검증',
  'creds.aside.verifyBody':    'URN으로 W3C Verifiable Credential 표준을 따라 외부 검증 가능합니다.',
  'creds.aside.standardLabel': '표준',
  'creds.justIssued':          '방금 발급',
  'creds.copied':              '복사됨',
  'creds.copyFailed':          '복사 실패',
  'creds.share':               '공유',
  'creds.verifyExternally':    '외부 검증',
  'creds.verifierComing':      '검증 포털은 곧 공개됩니다.',
  'creds.shareNative':         '공유',
  'creds.print':               '인쇄·PDF',
  'source.curated':         '큐레이션',
  'source.user_upload':     '사용자 업로드',
  'source.partner':         '제휴',
  'source.public_domain':   '저작권 만료',
  'source.institution':     '기관',

  'auth.signinTitle':       '로그인',
  'auth.signupTitle':       '회원가입',
  'auth.magicTitle':        '매직 링크',
  'auth.email':             '이메일',
  'auth.password':          '비밀번호',
  'auth.signin':            '로그인',
  'auth.signup':            '계정 만들기',
  'auth.sendMagic':         '매직 링크 보내기',
  'auth.switchToSignup':    '계정이 없으신가요? 회원가입',
  'auth.switchToSignin':    '이미 계정이 있으신가요? 로그인',
  'auth.switchToMagic':     '매직 링크로 로그인',
  'auth.notConfiguredBanner': 'Supabase가 설정되지 않았습니다. packages/web-app/.env.local에 VITE_SUPABASE_URL 과 VITE_SUPABASE_ANON_KEY 를 추가하세요.',
  'auth.checkEmail':        '이메일을 확인해 계정을 인증하세요.',
  'auth.magicSent':         '매직 링크를 보냈습니다 — 이메일을 확인하세요.',
  'auth.working':           '진행 중…',
  'auth.aside.whyLabel':       '왜 BookQuest 인가',
  'auth.aside.why1':           '한 권을 4-Layer 마인드맵으로 시각화',
  'auth.aside.why2':           '9-Tier 평가로 독해력을 측정',
  'auth.aside.why3':           '평생 인증서로 누적 기록',
  'auth.aside.privacyLabel':   '개인정보',
  'auth.aside.privacyBody':    '학습 데이터는 본인만 열람합니다.',

  'upload.title':           '책 올리기',
  'upload.help':            'PDF만 가능합니다. 전역 중복 제거가 적용되어, 이미 누군가가 처리한 파일이면 즉시 무료로 접근할 수 있습니다.',
  'upload.fileLabel':       'PDF 파일',
  'upload.countryLabel':    '국가 (가격 적용)',
  'upload.submit':          '업로드',
  'upload.submitting':      '업로드 중…',
  'upload.chooseFirst':     '먼저 PDF를 선택하세요.',
  'upload.failed':          '업로드 실패',
  'upload.resultTitle':     '결과',
  'upload.dedupeStatus':    '중복 상태',
  'upload.paymentStatus':   '결제 상태',
  'upload.amount':          '금액',
  'upload.jobId':           '작업 ID',
  'upload.eta':             '예상 소요',
  'upload.watchProgress':   '진행률 보기',
  'job.title':              '분석 진행',
  'job.processing':         '책을 분석하고 문제를 만드는 중…',
  'job.stage':              '단계',
  'job.cost':               '누적 비용',
  'job.done':               '완료되었습니다',
  'job.failed':             '처리 중 오류가 발생했습니다',
  'job.openBook':           '책으로 가기',
  'job.eta':                '보통 20분 내외 걸립니다. 창을 닫아도 백그라운드로 계속됩니다.',
  'upload.aside.formatLabel':  '지원 포맷',
  'upload.aside.formatBody':   'PDF · 텍스트 추출이 가능한 책. 50 MB 이내.',
  'upload.aside.etaLabel':     '예상 처리 시간',
  'upload.aside.etaBody':      '5–15분. 책 분량과 줄서기에 따라 달라집니다.',
  'upload.aside.privacyLabel': '개인정보',
  'upload.aside.privacyBody':  '업로드 PDF는 분석 후 즉시 폐기됩니다.',
  'nav.achievements':       '성취',
  'nav.admin':              '관리자',
  'gam.kicker':             '나의 여정',
  'gam.heroLine':           '읽고, 풀고,',
  'gam.heroEm':             '성장한다',
  'gam.heroSub':            '문제를 풀고 책을 완독할 때마다 XP가 쌓이고 뱃지를 얻습니다. 레벨을 올려 리더보드에 이름을 새기세요.',
  'gam.levelLabel':         '레벨',
  'gam.xpTotal':            '누적 XP',
  'gam.xpUnit':             'XP',
  'gam.toNext':             '다음 레벨까지',
  'gam.maxLevel':           '최고 레벨',
  'gam.badges':             '뱃지',
  'gam.badgesSub':          '학습의 자취',
  'gam.locked':             '미획득',
  'gam.noBadges':           '아직 획득한 뱃지가 없습니다 — 첫 문제부터 시작하세요.',
  'gam.leaderboard':        '리더보드',
  'gam.leaderboardSub':     'XP 순위',
  'gam.rank':               '순위',
  'gam.you':                '나',
  'gam.emptyBoard':         '아직 순위가 없습니다.',
  'gam.period.daily':       '오늘',
  'gam.period.weekly':      '이번 주',
  'gam.period.monthly':     '이번 달',
  'gam.period.all':         '전체',
  'gam.howXp':              'XP 획득 방법',
  'gam.howXpSub':           '이렇게 XP가 쌓입니다',
  'gam.levelCurve':         '레벨 곡선',
  'gam.levelN':             'Lv',
  'gam.aside.label':        'XP란?',
  'gam.aside.body':         'XP는 학습 활동의 누적 기록입니다. 정답·단계 완료·완독이 모두 더해져 레벨이 됩니다.',
  'gam.aside.fairLabel':    '공정한 적립',
  'gam.aside.fairBody':     '같은 문제를 반복해 풀어도 XP는 첫 정답에만 한 번 적립됩니다.',
  'gam.xpRule.answer_correct':     '문제 정답',
  'gam.xpRule.stage_complete':     '단계 완료',
  'gam.xpRule.book_clear':         'Book 완독',
  'gam.xpRule.cr_submit':          '서술형 제출',
  'gam.xpRule.streak_day':         '연속 학습(1일)',
  'gam.xpRule.question_propose':   '문제 제안',
  'gam.xpRule.question_adopted':   '제안 채택',
  'gam.xpRule.review_participate': '리뷰 참여',
  'detail.propose':            '문제 제안',
  'prop.title':                '문제 제안하기',
  'prop.help':                 '이 책에 어울리는 객관식 문제를 직접 만들어 제안하세요. 운영자가 채택하면 문제은행에 추가되고 XP와 뱃지를 얻습니다.',
  'prop.stemLabel':            '문제 (지문/발문)',
  'prop.stemPlaceholder':      '예) 이 장에서 주인공이 떠난 이유로 가장 알맞은 것은?',
  'prop.choicesLabel':         '보기 (정답을 선택하세요)',
  'prop.choiceCorrect':        '정답',
  'prop.choicePlaceholder':    '보기 내용',
  'prop.explanationLabel':     '해설 (선택)',
  'prop.explanationPlaceholder': '정답의 근거를 본문에서 들어 설명하세요.',
  'prop.submit':               '제안 제출',
  'prop.submitting':           '제출 중…',
  'prop.success':              '제안이 접수되었습니다. 검토 후 채택되면 알려드릴게요.',
  'prop.needStem':             '문제 내용을 입력하세요.',
  'prop.needChoices':          '보기를 2개 이상 채우세요.',
  'prop.needCorrect':          '정답 보기를 선택하세요.',
  'prop.myProposals':          '내 제안',
  'prop.none':                 '아직 제안한 문제가 없습니다.',
  'prop.status.pending':       '검토 대기',
  'prop.status.accepted':      '채택됨',
  'prop.status.rejected':      '반려됨',
  'prop.aside.howLabel':       '어떻게 되나요?',
  'prop.aside.howBody':        '제안 → 운영자 검토 → 채택 시 문제은행 편입(추가 검수 후 노출). 좋은 문제일수록 채택률이 높아요.',
  'prop.aside.rewardLabel':    '보상',
  'prop.aside.rewardBody':     '제안하면 XP, 채택되면 더 많은 XP와 “문제 제안자” 뱃지를 받습니다.',
  'prop.difficulty':           '난이도 제안 (선택)',
  'prop.difficultyNone':       '미지정',
  'detail.report':            '성취 리포트',
  'quiz.celebration.viewReport': '리포트 보기',
  'report.kicker':            '평가 리포트',
  'report.title':             '성취 리포트',
  'report.accuracy':          '전체 정답률',
  'report.level':             '숙련도',
  'report.theta':             '능력 추정(θ)',
  'report.thetaNote':         '상대 추정값 — 보정 전 근사',
  'report.attempted':         '푼 문항',
  'report.unit':              '문항',
  'report.naep':              'NAEP 인지영역',
  'report.lidia':             'LIDIA 평가영역',
  'report.trend':             '성장 추세',
  'report.window':            '구간',
  'report.notAttempted':      '미응시',
  'report.empty':             '아직 평가 기록이 없어요',
  'report.emptySub':          '문제를 풀면 영역별 성취가 여기에 쌓입니다.',
  'report.startQuiz':         '평가 시작',
  'report.honestyLabel':      '지표 안내',
  'report.honestyBody':       '레벨·θ는 보정 전 상대 근사값입니다. 표준 측정점수(Lexile·수능 등급)가 아닙니다.',
  'report.viewCredential':    '인증서 보기',
  'report.viewAchievements':  '성취·XP',
  'report.retry':             '다시 풀기',
  'report.naep.locate_recall':       '찾기·기억',
  'report.naep.integrate_interpret': '통합·해석',
  'report.naep.critique_evaluate':   '비판·평가',
  'footer.larc':              '검토 위원회',
  'larc.kicker':             '신뢰와 투명성',
  'larc.title':              'LARC 검토 위원회',
  'larc.lead':               '모든 문항은 AI 생성 후 다단계 검토를 거칩니다. LARC는 그 과정을 공개합니다.',
  'larc.missionLabel':       '사명',
  'larc.missionBody':        '평가의 공정성과 정확성을 지킵니다. AI가 만든 문항을 사람·교차모델이 검증해 신뢰할 수 있는 문해력 측정을 제공합니다.',
  'larc.criteriaLabel':      '심사 기준',
  'larc.crit1':              '근거 정합성 — 정답이 본문에 실제로 근거하는가',
  'larc.crit2':              '명확성 — 문항·보기가 모호하지 않은가',
  'larc.crit3':              '변별력 — 오답이 그럴듯하고 정답이 유일한가',
  'larc.crit4':              '학년·편향 — 대상 학년에 적합하고 편향이 없는가',
  'larc.statsLabel':         '검토 활동',
  'larc.stApproved':         '승인',
  'larc.stPending':          '검토 대기',
  'larc.stReviewed':         'AI 검토',
  'larc.stRejected':         '반려',
  'larc.stTotal':            '전체 문항',
  'larc.stReports':          '신고 처리',
  'larc.note':               '집계 수치만 공개되며 개인정보·문항 내용은 포함되지 않습니다.',
  'prelearn.title':          '사전학습',
  'prelearn.subtitle':       '읽기 전 배경지식',
  'prelearn.books':          '구매·서점',
  'prelearn.media':          '영상·배경',
  'prelearn.note':           '외부 사이트 검색으로 이동합니다.',
  'creds.summaryLabel':      '종합 문해력 인증',
  'creds.summaryTotal':      '총 인증',
  'creds.summaryBooks':      '커버한 책',
  'creds.summaryHighest':    '최고 등급',
  'nav.vault':               '지식창고',
  'vault.title':             '지식 창고',
  'vault.subtitle':          '메모·인상문장·통찰 모아두기',
  'vault.kindMemo':          '메모',
  'vault.kindQuote':         '인상문장',
  'vault.kindInsight':       '통찰',
  'vault.kindFeedback':      '피드백',
  'vault.contentPlaceholder': '기억하고 싶은 내용을 적으세요',
  'vault.tagsPlaceholder':   '태그 (쉼표 구분)',
  'vault.add':               '저장',
  'vault.searchPlaceholder': '내용 검색',
  'vault.allKinds':          '전체',
  'vault.empty':             '아직 저장한 노트가 없습니다.',
  'vault.delete':            '삭제',
  'vault.added':             '저장했습니다.',
  'vault.deleted':           '삭제했습니다.',
  'vault.needContent':       '내용을 입력하세요.',
  'vault.export':            '내보내기',
  'vault.exportMd':          'Markdown',
  'vault.exportJson':        'JSON',
  'verify.title':            '인증서 검증',
  'verify.checking':         '검증 중…',
  'verify.valid':            '유효한 인증서입니다',
  'verify.invalid':          '무효 또는 취소된 인증서입니다',
  'verify.notFound':         '인증서를 찾을 수 없습니다',
  'verify.tier':             '등급',
  'verify.issued':           '발급일',
  'verify.note':             'BookQuest 발급 기록과 대조해 검증합니다. 개인정보는 노출되지 않습니다.',
};

export default ko;
